import React from 'react';
import SectionTitle from '../SectionTitle';

const PageShell = Page => {
    return props => {
        console.log(props);
        return (
            <div className="app-page-shell animated slideInDown">
                <div className="app-shell-left">
                    <div className="app-message-box">
                        <SectionTitle {...props} />
                    </div>
                </div>
                <div className="app-shell-right animated fadeIn">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Page {...props} />
                            </div>
                        </div>
                    </div>
                </div>
                {/*
                <div className="col-md-7">
                    
                </div>
                <div className="col-md-5">
                    <Page {...props} />
                </div>
                */}
            </div>
        );
    }
}

export default PageShell;


// WEBPACK FOOTER //
// ./src/Shared/PageShell.js